import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Stage, Vehicle } from '../../types';
import img from '../../assets/images/image1.png';

interface VehicleSliceState {
  isInitialized: boolean;
  data: Vehicle;
  selectedStage: string;
  currentStage: string;
  quickGlanceData: any;
}

const initialState: VehicleSliceState = {
  isInitialized: false,
  data: {
    _id: '',
    VIN: '',
    trim: '',
    currentStatus: '',
    reservationId: '',
    inTransitToLocation: '',
    lucidId: '',
    Last_Name__C: '',
    First_Name__C: '',
    stage: 'Reserved',
    customerName: '',
    deliveryPercentage: '',
    deliveryScheduledDate: '',
    email: '',
    phone: '',
    reservationDate: '',
    customerStage: '' as Stage,
    stageUpdatedDate: '',
    configuration: { imageUrl: '' },
    assignmentType: '',
    batchNumber: '',
    deliveryDoc: {
      deliveryHandoffDate: '',
    },
    action: '',
    disabled: '',
    category: '',
    subCategory: '',
  },
  selectedStage: 'Reserved',
  currentStage: 'Reserved',
  quickGlanceData: null,
};

export const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
    setVehicle(state, action: PayloadAction<Vehicle>) {
      state.data = action.payload;
      state.isInitialized = true;
    },
    setSelectedStage(state, action: PayloadAction<string>) {
      state.selectedStage = action.payload;
    },
    setCurrentStage(state, action: PayloadAction<string>) {
      state.currentStage = action.payload;
    },
    setQuickGlanceData(state, action) {
      state.quickGlanceData = action.payload;
    },
  },
});

export const { setVehicle, setSelectedStage, setCurrentStage, setQuickGlanceData } = vehicleSlice.actions;
export default vehicleSlice.reducer;
